



























import Vue from 'vue'
import { BadgeLabelElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BadgeIconStatus',
  props: {
    templateItemData: {
      type: Object as () => BadgeLabelElInterface,
      required: true
    }
  },
  computed: {
    badgeStyle (): Record<string, string> {
      return {
        fontSize: '0.85rem',
        display: 'inline-flex',
        background: this.templateItemData.badge.badgeColor ? this.templateItemData.badge.badgeColor : 'transparent',
        color: this.templateItemData.badge.badgeTextColor ? this.templateItemData.badge.badgeTextColor : 'inherit'
      }
    }
  }
})
